import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HistoryContext } from '../context/history.context';
import { ActionsContext } from '../context/actions.context';
import Base from "../layout/Base.layout";
import isLoggedInQuery from "../graphql/queries/isLoggedIn.query";

type Props = {
  menuOpened: Boolean,
  setMenuOpened: () => {},
  menuItems: [],
  moduleName: String,
  menuTitle: String,
  logout: () => {},
  logoutComponent: any,
  activeOrder: Boolean,
};

const AppBar = (props: Props) => {
  const { menuOpened, setMenuOpened, menuItems, moduleName, menuTitle, logoutComponent, activeOrder } = props;
  const history = useContext(HistoryContext);
  const { setRefresh, goBack, allScreens, appTitle } = useContext(ActionsContext);

  const mobileLogout = (logoutAction) =>
    <button className='logout-button' onClick={() => { logoutAction().catch(() => { }) }}>
      <img src='assets/logout.svg' alt='logout icon'/>
      Logout
    </button>

  const icons = {
    accounts: 'assets/accounts.svg',
    inventory: 'assets/inventory.svg',
    invoices: 'assets/invoices.svg',
    orders: 'assets/orders.svg',
    shipping: 'assets/shipping.svg',
    salesanalysis: 'assets/salesanalysis.svg',
    samples: 'assets/samples.svg',
    coops: 'assets/coops.svg'
  };

  const screenDisplayed = allScreens[allScreens.length - 1];
  const title = screenDisplayed && screenDisplayed.title;
  const orderModule = moduleName === 'order';
  const orderTitle = orderModule && !title && appTitle;

  const isUserLoggedIn = () => {
    Base.getClient().query({query: isLoggedInQuery, fetchPolicy: 'network-only'})
  }

  return (
    <div>
      {moduleName !== 'order' && !title ? (
        <div className='appbar'>
          <div className='app-title'>
            <a href={menuOpened ? '/' : '/' + moduleName}>{menuOpened ? 'Polaner Sales Portal' : menuTitle}</a>
          </div>
          <div className='appbar-button-group'>
            {!menuOpened && (
              <button
                className='appbar-cart'
                onClick={() => {
                  isUserLoggedIn();
                  history.push('/order');
                  setMenuOpened(false);
                }}
              >
                <div className='cart-group'>
                  {activeOrder && <div className='cart-number'>1</div>}
                  <img src='assets/cart.svg' alt='cart icon'/>
                </div>
              </button>
            )}
            <button
              className='menu-button'
              onClick={() => {
                !menuOpened && isUserLoggedIn();
                setMenuOpened(!menuOpened);
              }}
            >
              {menuOpened ? (
                <img src='assets/close.svg' alt='close menu icon'/>
              ) : (
                <img src='assets/menu.svg' alt='menu icon'/>
              )}
            </button>
          </div>
        </div>
      ) : (
        <div className='appbar'>
          <button className='menu-button' onClick={() => {
            isUserLoggedIn()
            title ? goBack() : history.goBack();
          }}>
            <img src='assets/arrow-left.svg' alt='back icon'/>
          </button>
          <div className='view-title' style={{ ...(title && { width: '100%', justifyContent: 'center' }) }}>{title || orderTitle || 'Order'}</div>
          {!title &&
            <button className='menu-button' onClick={() => {
              isUserLoggedIn()
              setRefresh(true)
            }}>
              <img src='assets/refresh.svg' alt='revfresh icon' />
            </button>
          }
        </div>
      )}
      <div className='menu-background' style={{ display: menuOpened ? 'flex' : 'none' }}>
        <div className='mobile-menu'>
          {menuItems && menuItems.map(item => {
            return (
              <Link key={item.id} to={'/' + item.text.toLowerCase()} onClick={() => {
                isUserLoggedIn();
                setMenuOpened(false);
              }}>
                <img src={icons[item.text.toLowerCase().replace(/\s/g, '')]} alt={item.text.toLowerCase()}></img>
                {item.text}
              </Link>
            )
          })
          }
        </div>
        <div className='menu-logout'>
          {logoutComponent(true, mobileLogout)}
        </div>
      </div>
    </div>
  );
};

export default AppBar;
